/* Azucarena: mobile touch sizes and product sheet. 2026-09-17. */
(function () {
  'use strict';
  var media = window.matchMedia('(max-width: 749px)');
  var activeCard = null, sheet = null, returnFocus = null, closingTimer = null;
  var busy = false, touch = null, suppressCard = null, suppressUntil = 0;
  function mobile() { return media.matches; }
  function closest(target, selector) { return target && target.closest ? target.closest(selector) : null; }
  function cardAt(x, y) {
    var card = closest(document.elementFromPoint(x, y), '.product-card-wrapper');
    return card && card.querySelector('.az-qs__btn') ? card : null;
  }
  function openCard(card) {
    if (activeCard === card) return;
    if (activeCard) activeCard.classList.remove('az-open');
    activeCard = card;
    if (card) card.classList.add('az-open');
  }
  /* Reveal sizes during touch, but navigate on the original tap before Safari hover can consume it. */
  document.addEventListener('touchstart', function (event) {
    touch = null; suppressCard = null; suppressUntil = 0;
    if (!mobile() || event.touches.length !== 1 || sheet) return;
    var point = event.touches[0];
    var card = closest(event.target, '.product-card-wrapper');
    openCard(card && card.querySelector('.az-qs__btn') ? card : null);
    if (!card) return;
    var control = closest(event.target, '[data-az-qs],button,input,select,textarea');
    var link = control ? null : closest(event.target, 'a[href]');
    if (!link && !control && closest(event.target, '.card__inner')) link = card.querySelector('a.az-qs-link[href]');
    if (link && (link.origin !== window.location.origin || link.pathname.indexOf('/products/') < 0)) link = null;
    var slider = card.closest('.slider');
    touch = {x:point.clientX,y:point.clientY,card:card,link:link,control:!!control,moved:false,started:Date.now(),pageY:window.scrollY,slider:slider,scrollX:slider ? slider.scrollLeft : 0};
  }, {passive:true,capture:true});
  document.addEventListener('touchmove', function (event) {
    if (!touch) return;
    if (event.touches.length !== 1) { touch = null; return; }
    var point = event.touches[0];
    if (Math.max(Math.abs(point.clientX-touch.x),Math.abs(point.clientY-touch.y)) > 12) touch.moved = true;
    var card = cardAt(point.clientX,point.clientY);
    if (card) openCard(card);
  }, {passive:true,capture:true});
  document.addEventListener('touchend', function (event) {
    var gesture = touch; touch = null;
    if (!gesture) return;
    var scrolled = Math.abs(window.scrollY-gesture.pageY)>4 || (gesture.slider && Math.abs(gesture.slider.scrollLeft-gesture.scrollX)>4);
    if (gesture.moved || scrolled) { suppressCard=gesture.card; suppressUntil=Date.now()+650; return; }
    if (!gesture.link || gesture.control || Date.now()-gesture.started>700 || !event.cancelable) return;
    event.preventDefault(); event.stopPropagation();
    suppressCard=gesture.card; suppressUntil=Date.now()+650;
    window.location.assign(gesture.link.href);
  }, {passive:false,capture:true});
  document.addEventListener('touchcancel',function(){touch=null;},{passive:true,capture:true});

  function status(container, message) {
    if (!container) return;
    var output = container.querySelector('[data-az-status]');
    if (!output) {
      output = document.createElement('p');
      output.setAttribute('data-az-status', '');
      output.setAttribute('role', 'status');
      output.className = 'az-status';
      container.appendChild(output);
    }
    output.textContent = message || '';
  }
  function closeSheet(restoreFocus) {
    if (!sheet) return;
    var old = sheet;
    sheet = null;
    document.documentElement.classList.remove('az-sheet-open');
    var trigger = returnFocus;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus !== false && trigger && trigger.isConnected) trigger.focus({preventScroll: true});
    clearTimeout(closingTimer);
    closingTimer = setTimeout(function () { if (sheet !== old) old.hidden = true; }, 300);
  }
  function openSheet(trigger) {
    var next = document.getElementById(trigger.getAttribute('data-az-open'));
    if (!next) return;
    if (sheet && sheet !== next) { sheet.hidden = true; closeSheet(false); }
    clearTimeout(closingTimer);
    returnFocus = trigger;
    if (next.parentNode !== document.body) document.body.appendChild(next);
    sheet = next;
    next.hidden = false;
    next.querySelector('.az-sheet__panel').scrollTop = 0;
    status(next.querySelector('.az-sheet__panel'), '');
    void next.offsetHeight;
    document.documentElement.classList.add('az-sheet-open');
    trigger.setAttribute('aria-expanded', 'true');
    var focus = next.querySelector('[data-az-close][type="button"]');
    if (focus) focus.focus({preventScroll: true});
    openCard(null);
  }
  async function addVariant(button, container, form, onSuccess) {
    if (busy || button.disabled || button.classList.contains('is-out')) return;
    var id = button.getAttribute('data-az-pick') || button.getAttribute('data-az-size');
    if (!id) return;
    busy = true;
    button.classList.add('is-load', 'is-loading');
    button.setAttribute('aria-busy', 'true');
    container.setAttribute('aria-busy', 'true');
    status(container, 'Agregando al carrito…');
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = form ? new FormData(form) : new FormData();
    body.set('id', id);
    if (!body.has('quantity')) body.set('quantity', '1');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.set('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }).join(','));
      body.set('sections_url', window.location.pathname);
      if (drawer.setActiveElement) drawer.setActiveElement(returnFocus || button);
    }
    var data;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: body});
      data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Esta talla ya no está disponible. Elige otra.');
    } catch (error) {
      status(container, error instanceof TypeError ? 'No pudimos confirmar si se agregó. Revisa tu carrito y tu conexión antes de intentar de nuevo.' : error.message || 'No pudimos agregar esta talla. Intenta de nuevo.');
      busy = false;
      button.classList.remove('is-load', 'is-loading');
      button.removeAttribute('aria-busy');
      container.removeAttribute('aria-busy');
      return;
    }
    busy = false;
    button.classList.remove('is-load', 'is-loading');
    button.removeAttribute('aria-busy');
    container.removeAttribute('aria-busy');
    status(container, 'Agregado al carrito');
    if (onSuccess) onSuccess();
    if (drawer && data.sections && typeof drawer.renderContents === 'function') {
      try {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } catch (error) { window.location.assign((window.routes && window.routes.cart_url) || '/cart'); }
    } else window.location.assign((window.routes && window.routes.cart_url) || '/cart');
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {source: 'az-mobile', productVariantId: id, cartData: data});
    }
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = closest(target, '[data-az-open]');
    if (trigger) { event.preventDefault(); event.stopPropagation(); openSheet(trigger); return; }
    if (closest(target, '[data-az-close]')) { event.preventDefault(); closeSheet(true); return; }
    if (closest(target, '[data-az-guide]') && sheet) {
      event.preventDefault();
      var info = document.querySelector('product-info.az-product-sheet-ready');
      var guide = info && Array.from(info.querySelectorAll('modal-opener button')).find(function (item) { return /gu[ií]a.*tallas/i.test(item.textContent); });
      closeSheet(true);
      if (guide) guide.click();
      return;
    }
    var pick = closest(target, '[data-az-pick]');
    if (pick && sheet) {
      event.preventDefault(); event.stopPropagation();
      var form = document.getElementById(sheet.getAttribute('data-az-form'));
      if (form) addVariant(pick, sheet.querySelector('.az-sheet__panel'), form, function () { closeSheet(false); });
      return;
    }
    var quickSize = closest(target, '.az-qs__btn[data-az-size]');
    var add = closest(target, '[data-az-add]');
    var card = closest(target, '.product-card-wrapper');
    if (mobile() && suppressCard === card && Date.now() < suppressUntil && !quickSize && !add) {
      event.preventDefault(); event.stopPropagation(); suppressUntil = 0; return;
    }
    if (quickSize) {
      event.preventDefault(); event.stopPropagation();
      if (quickSize.disabled || quickSize.classList.contains('is-out')) return;
      var panel = quickSize.closest('[data-az-qs]');
      addVariant(quickSize, panel, null, function () { openCard(null); });
      return;
    }
    if (add) {
      event.preventDefault(); event.stopPropagation();
      var quick = add.closest('[data-az-qs]');
      addVariant(add, quick, null, function () { openCard(null); });
      return;
    }
    if (mobile() && !closest(target, '.product-card-wrapper.az-open')) openCard(null);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { closeSheet(true); openCard(null); }
    if (!sheet || event.key !== 'Tab') return;
    var focusable = Array.from(sheet.querySelectorAll('button:not([disabled]),a[href]')).filter(function (item) { return item.getClientRects().length; });
    var first = focusable[0], last = focusable[focusable.length-1];
    if (event.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function init() {
    document.querySelectorAll('product-info[data-update-url="true"]').forEach(function(info) {
      var form = info.querySelector('product-form');
      if (!form) return;
      info.classList.add('az-product-layout-ready');
      if (form.parentElement) form.parentElement.classList.add('az-buy-block');
      var variants = info.querySelector('variant-selects');
      var hasChoices = variants && (Array.from(variants.querySelectorAll('fieldset')).some(function(field) { return field.querySelectorAll('input[type="radio"]').length > 1; }) || Array.from(variants.querySelectorAll('select')).some(function(select) { return select.options.length > 1; }));
      info.classList.toggle('az-product-single-option', !hasChoices);
      Array.from(info.querySelectorAll('modal-opener')).forEach(function(opener) {
        if (/gu[ií]a.*tallas/i.test(opener.textContent)) opener.classList.add('az-size-guide-opener');
      });
      var trigger = info.querySelector('[data-az-open]');
      if (!trigger) return;
      info.classList.add('az-product-sheet-ready');
      var sizeGuide = info.querySelector('[data-az-guide]');
      if (sizeGuide) sizeGuide.hidden = !info.querySelector('.az-size-guide-opener');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', trigger.getAttribute('data-az-open'));
      trigger.setAttribute('aria-expanded', 'false');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  media.addEventListener('change', function () { if (!mobile()) { closeSheet(true); openCard(null); } });
})();

/* azNoConfetti: quita la animacion de confeti (canvas a pantalla completa de una app) al agregar al carrito */
(function () {
  function esConfeti(n) {
    if (!n || n.nodeType !== 1 || n.tagName !== 'CANVAS') return false;
    if (n.parentElement !== document.body) return false;
    var cs = window.getComputedStyle(n);
    if (cs.position !== 'fixed') return false;
    if ((parseInt(cs.zIndex, 10) || 0) < 9000) return false;
    var r = n.getBoundingClientRect();
    return r.width > window.innerWidth * 0.8 && r.height > window.innerHeight * 0.8;
  }
  function limpiar() {
    var list = document.body ? document.body.children : [];
    for (var i = list.length - 1; i >= 0; i--) { if (esConfeti(list[i])) list[i].remove(); }
  }
  function iniciar() {
    limpiar();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var add = muts[i].addedNodes;
        for (var j = 0; j < add.length; j++) { if (esConfeti(add[j])) add[j].remove(); }
      }
    }).observe(document.body, { childList: true });
  }
  if (document.body) iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);
})();



/* az: arrastre horizontal de carruseles de colecciones en desktop */
(function () {
  'use strict';
  function init(root) {
    var slider = root.querySelector('.slider--desktop');
    if (!slider || slider.hasAttribute('data-az-drag-ready')) return;
    slider.setAttribute('data-az-drag-ready', '');
    var down = false, moved = false, startX = 0, startScroll = 0, clickBlockedUntil = 0;
    slider.addEventListener('dragstart', function(e) { e.preventDefault(); });
    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || window.matchMedia('(max-width: 749px)').matches) return;
      if (e.target.closest('button, input, select, [data-az-qs]')) return;
      down = true; moved = false; clickBlockedUntil = 0; startX = e.clientX; startScroll = slider.scrollLeft;
    });
    slider.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) <= 6) return;
      if (!moved) { moved = true; slider.setPointerCapture(e.pointerId); slider.classList.add('az-dragging'); }
      slider.scrollLeft = startScroll - dx;
      e.preventDefault();
    });
    function end(e) {
      if (!down) return;
      down = false; slider.classList.remove('az-dragging');
      if (e && slider.hasPointerCapture && slider.hasPointerCapture(e.pointerId)) slider.releasePointerCapture(e.pointerId);
      if (moved) clickBlockedUntil = Date.now() + 650;
      moved = false;
    }
    slider.addEventListener('pointerup', end);
    slider.addEventListener('pointercancel', end);
    slider.addEventListener('pointerleave', function(e) { if (!moved) end(e); });
    slider.addEventListener('click', function (e) {
      if (Date.now() < clickBlockedUntil) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }
  function scan() { document.querySelectorAll('slider-component').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, {childList: true, subtree: true});
})();
/* Azucarena: horizontal gallery, native touch and mouse dragging. */
(function(){
'use strict';
function initGallery(list){
 if(list.dataset.azGalleryReady)return;
 list.dataset.azGalleryReady='true';
 list.setAttribute('tabindex','0');list.setAttribute('aria-label','Fotos del producto. Usa las flechas para cambiar de foto.');
 list.querySelectorAll('img').forEach(function(img){img.draggable=false;});
 var pointer=null,startX=0,startY=0,startScroll=0,moved=false,blockUntil=0,touchStart=null;
 list.addEventListener('dragstart',function(e){e.preventDefault();});
 list.addEventListener('touchstart',function(e){touchStart=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
 list.addEventListener('touchmove',function(e){if(touchStart&&e.touches.length===1&&(Math.abs(e.touches[0].clientX-touchStart.x)+Math.abs(e.touches[0].clientY-touchStart.y)>8))blockUntil=Date.now()+700;},{passive:true});
 list.addEventListener('touchend',function(){touchStart=null;},{passive:true});
 list.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('video,deferred-media,model-viewer'))return;pointer=e.pointerId;startX=e.clientX;startY=e.clientY;startScroll=list.scrollLeft;moved=false;});
 list.addEventListener('pointermove',function(e){if(pointer!==e.pointerId)return;var dx=e.clientX-startX;if(Math.abs(dx)+Math.abs(e.clientY-startY)>6)blockUntil=Date.now()+700;if(!moved&&Math.abs(dx)<6)return;if(!moved){moved=true;list.classList.add('az-gallery-dragging');list.setPointerCapture(e.pointerId);}e.preventDefault();list.scrollLeft=startScroll-dx;});
 function finish(e){if(pointer!==e.pointerId)return;pointer=null;if(list.hasPointerCapture(e.pointerId))list.releasePointerCapture(e.pointerId);if(moved){blockUntil=Date.now()+700;list.classList.remove('az-gallery-dragging');var slides=Array.from(list.children).filter(function(x){return x.offsetWidth>0;});var target=slides.reduce(function(best,x){return !best||Math.abs(x.offsetLeft-list.offsetLeft-list.scrollLeft)<Math.abs(best.offsetLeft-list.offsetLeft-list.scrollLeft)?x:best;},null);if(target)list.scrollTo({left:target.offsetLeft-list.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}moved=false;}
 list.addEventListener('pointerup',finish);list.addEventListener('pointercancel',finish);list.addEventListener('lostpointercapture',function(){pointer=null;list.classList.remove('az-gallery-dragging');});
 list.addEventListener('click',function(e){if(Date.now()<blockUntil){e.preventDefault();e.stopImmediatePropagation();}},true);
 list.addEventListener('keydown',function(e){if(e.target!==list||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();var first=list.querySelector('.product__media-item');if(first)list.scrollBy({left:(first.offsetWidth+parseFloat(getComputedStyle(list).columnGap||0))*(e.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
}
function scan(){document.querySelectorAll('product-info[data-update-url="true"] .product__media-list').forEach(initGallery);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
document.addEventListener('shopify:section:load',scan);
})();
